// src/components/Footer/Footer.jsx

import React from 'react';
import './Footer.css'; 
import { Link } from 'react-router-dom';
import logo from '../../assets/sancakLogo.png'; 
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-wrapper">
        
        {/* Sütun 1: Logo ve Sosyal Medya */}
        <div className="footer-col footer-col-logo">
          <Link to="/" className="footer-logo-link">
            <img src={logo} alt="Sancak Hırdavat Ankastre" className="footer-logo-img" />
          </Link>
          <p className="footer-about">
            Modern mutfak ve hırdavat çözümleriniz için tek adres.
          </p>
          <div className="footer-social-icons">
            {/* TODO: Gerçek linkleri buraya ekle */}
            <a href="https://facebook.com" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://wa.me/905327233567" aria-label="Whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
          </div>
        </div>
        
        {/* Sütun 2: Hızlı Linkler (Hakkımızda GÜNCELLENDİ) */}
        <div className="footer-col">
          <h4 className="footer-col-title">Hızlı Linkler</h4>
          <ul className="footer-links-list">
            <li><Link to="/">Anasayfa</Link></li>
            {/* --- DEĞİŞİKLİK BURADA --- */}
            <li><Link to="/#neden-sancak">Hakkımızda</Link></li>
            <li><Link to="/urunler">Tüm Ürünler</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>
          </ul>
        </div>
        
        {/* Sütun 3: Ürün Grupları (Linkler GÜNCELLENDİ) */}
        <div className="footer-col">
          <h4 className="footer-col-title">Ürün Grupları</h4>
          <ul className="footer-links-list">
            {/* --- DEĞİŞİKLİK BURADA: Linkler query parametresi kullanıyor --- */}
            {/* Not: Bu isimler Firestore'daki 'name' ile eşleşmeli */}
            <li><Link to="/urunler?kategori=Ankastre Setler">Ankastre Çeşitleri</Link></li>
            <li><Link to="/urunler?kategori=Eviyeler">Eviye Çeşitleri</Link></li>
            <li><Link to="/urunler?kategori=Bataryalar">Batarya Çeşitleri</Link></li>
            <li><Link to="/urunler?kategori=Aspiratörler">Aspiratör Çeşitleri</Link></li>
          </ul>
        </div>
        
        <div className="footer-col">
          <h4 className="footer-col-title">İletişim</h4>
          <ul className="footer-contact-list">
            <li>
              <FaMapMarkerAlt />
              <span>Koçak Sokak no:57 Siteler Ankara/Altındağ</span>
            </li>
            <li>
              <FaPhoneAlt />
              {/* TODO: Gerçek telefonu güncelle */}
              <a href="tel:+905327233567">+90 532 723 35 67</a>
            </li>
            <li>
              <FaEnvelope />
              <a href="mailto:info@sancakticaret.com">info@sancakticaret.com</a>
            </li>
          </ul>
        </div>
        
      </div>
      
      {/* Alt Bar: Copyright */}
      <div className="footer-bottom-bar">
        <p>
          &copy; {new Date().getFullYear()} Sancak Hırdavat Ankastre. 
          Tüm hakları saklıdır.
        </p>
      </div>
    </footer>
  );
}

export default Footer;